import { SUBSCRIPTION_KEY, API_BASE } from '../utils/constants';

const getSubscribers = () => {
  try {
    const data = localStorage.getItem(SUBSCRIPTION_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
};

const saveSubscribers = (subs) => {
  localStorage.setItem(SUBSCRIPTION_KEY, JSON.stringify(subs));
};

// Sync to backend — fire and forget, never blocks the UI
async function syncToBackend(email, mobile, preferences) {
  try {
    const res = await fetch(`${API_BASE}/api/auth/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, mobile, ...preferences }),
      signal: AbortSignal.timeout(10000),
    });
    if (!res.ok) console.warn('[Subscribe] Backend returned', res.status);
  } catch (err) {
    console.warn('[Subscribe] Backend sync failed (offline?):', err.message);
  }
}

export const addSubscriber = (email, mobile, name) => {
  const subscribers = getSubscribers();

  const cleanEmail = email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? email.toLowerCase().trim() : '';
  const cleanMobile = mobile ? mobile.replace(/\D/g, '').slice(-10) : '';

  // Check for duplicate
  const exists = subscribers.find(s =>
    (cleanEmail && s.email === cleanEmail) || (cleanMobile && s.mobile === cleanMobile)
  );
  if (exists) {
    if (name && !exists.name) { exists.name = name; saveSubscribers(subscribers); }
    return { success: false, message: 'आप पहले से सदस्य हैं!' };
  }

  // Infer preferences from what the user provided
  // email provided → wants email updates + PDF; mobile → wants WhatsApp
  const wants_email = cleanEmail ? 1 : 0;
  const wants_pdf = cleanEmail ? 1 : 0;
  const wants_whatsapp = cleanMobile ? 1 : 0;

  const newSub = {
    id: Date.now().toString(36),
    name: name || '',
    email: cleanEmail,
    mobile: cleanMobile ? `+91${cleanMobile}` : '',
    wantsEmail: !!wants_email,
    wantsPdf: !!wants_pdf,
    wantsWhatsapp: !!wants_whatsapp,
    subscribedAt: new Date().toISOString(),
  };
  subscribers.push(newSub);
  saveSubscribers(subscribers);

  // Sync to backend without blocking
  syncToBackend(
    cleanEmail || null,
    cleanMobile ? `+91${cleanMobile}` : null,
    { wants_email, wants_pdf, wants_whatsapp, name: name || undefined }
  );

  return { success: true, message: 'सदस्यता सफल! धन्यवाद!' };
};

export const getAllSubscribers = () => {
  return getSubscribers();
};

export const getSubscriberCount = () => {
  return getSubscribers().length;
};

export const deleteSubscriber = (id) => {
  const subscribers = getSubscribers();
  const filtered = subscribers.filter(s => s.id !== id);
  saveSubscribers(filtered);
  return true;
};

export const markUnsubscribed = (email, mobile) => {
  const subscribers = getSubscribers();
  let changed = false;
  subscribers.forEach(s => {
    if ((email && s.email === email) || (mobile && s.mobile === mobile)) {
      s.isSubscribed = false;
      s.unsubscribedAt = new Date().toISOString();
      changed = true;
    }
  });
  if (changed) saveSubscribers(subscribers);
};

export const exportSubscribersCSV = () => {
  const subscribers = getSubscribers();
  if (subscribers.length === 0) return null;

  const headers = ['#', 'Email', 'Mobile', 'PDF', 'Email Updates', 'WhatsApp', 'Subscribed On'];
  const rows = subscribers.map((s, i) => [
    i + 1,
    s.email,
    s.mobile,
    s.wantsPdf ? 'Yes' : 'No',
    s.wantsEmail ? 'Yes' : 'No',
    s.wantsWhatsapp ? 'Yes' : 'No',
    new Date(s.subscribedAt).toLocaleString('hi-IN'),
  ]);

  const csvContent = [headers, ...rows]
    .map(row => row.join(','))
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `subscribers_${new Date().toISOString().slice(0, 10)}.csv`;
  link.click();
  URL.revokeObjectURL(url);
  return true;
};
